import type { ReactNode } from "react";

import { cn } from "@/lib/cn";

export type TagTone = "default" | "red" | "green" | "gold" | "blue" | "violet";

const TONE_CLASS: Record<TagTone, string> = {
  default: "",
  red: "is-red",
  green: "is-green",
  gold: "is-gold",
  blue: "is-blue",
  violet: "is-violet",
};

export interface TagProps {
  tone?: TagTone;
  className?: string;
  children: ReactNode;
}

/** 原型基元：`.tag`（可附加 `.is-red/.is-green/.is-gold/.is-blue`）。 */
export function Tag({ tone = "default", className, children }: TagProps) {
  return <span className={cn("tag", TONE_CLASS[tone], className)}>{children}</span>;
}
